<template lang="pug">
div
  v-breadcrumbs.py-4(:items="breadcrumbItems")
    template(v-slot:item="{ item }")
      a.text-xs.no-underline.primary--text(v-if="!item.disabled" :href="item.href") {{ item.text }}
      .text-xs.primary400--text(v-else) {{ item.text }}
  v-divider.mb-2
  v-container.px-6.primary--text
    v-row
      v-col(cols="12" sm="4" md="6")
        .text-2xl.font-semibold.mb-2 {{ headerInfo[stepPosition - 1].title }}
        .text-md {{ headerInfo[stepPosition - 1].description }}
      v-col(cols="12" sm="4" md="6")
        v-stepper(alt-labels v-model="stepPosition")
          .d-flex.align-center
            .text-center.mx-1.text-sm
              template(v-if="stepPosition === 1")
                v-btn.font-bold.mb-1(fab outlined depressed x-small color="#14AE5C") 
                  .primary--text.text-sm 1
                .font-bold {{ $t('name') }}
              template(v-else)
                v-btn.font-bold.mb-1(fab depressed x-small color="#14AE5C" dark)
                  .text-sm 1
                div {{ $t('name') }}
            v-divider.mb-6(:color="stepPosition > 1 ? '#14AE5C' : ''")
            .text-center.mx-1.text-sm
              template(v-if="stepPosition > 2")
                v-btn.font-bold.mb-1(fab depressed x-small color="#14AE5C" dark)
                  .text-sm 2
                div {{ $t('customer') }}
              template(v-else)
                v-btn.font-bold.mb-1(fab outlined depressed x-small color="#14AE5C" :disabled="stepPosition !== 2")
                  .primary--text.text-sm 2
                div(:class="{'font-bold' : stepPosition === 2}") {{ $t('customer') }}
            v-divider.mb-6(:color="stepPosition > 2 ? '#14AE5C' : ''")
            .text-center.mx-1.text-sm
              v-btn.font-bold.mb-1(fab outlined depressed x-small color="#14AE5C" :disabled="stepPosition !== 3")
                .primary--text.text-sm 3
              div(:class="{'font-bold' : stepPosition === 3}") {{ $t('finish') }}
    v-stepper(v-model="stepPosition" elevation="10")
      v-stepper-items.mt-4
        v-stepper-content.pa-0(step="1")
          segment-name(@click="stepPosition = 2" :title.sync="title" :description.sync="description")
        v-stepper-content.pa-0(step="2")
          component(:is="audienceComponent" isSelectionMode="true" @onContinue="onContinue" @onSelectedCustomers="updateSelectedCustomers")
            template(v-slot:actions)
              .d-flex.mt-4
                v-btn.button-md(@click="backToName" color="neutral500" text) {{ $t('back') }}
                v-spacer
                v-btn.button-md(@click="clickContinue" color="info" :disabled="!selectedCustomers.length" depressed) {{ $t('continue') }}
        v-stepper-content.pa-0(step="3")
          segment-summary(:os="os" :name="title" :description="description" :customers="selectedCustomers" @onBack="onBack")
</template>

<script>
import SegmentName from './SegmentName.vue'
import SegmentSummary from './SegmentSummary.vue'
import CustomerList from '@/views/admin/connect/customers/CustomerList.vue'
import Patients from '@/views/admin/clinic/Patients.vue'

export default {
  props: {
    os: {
      type: String,
      default: null
    }
  },
  components: { 
    CustomerList,
    SegmentName,
    SegmentSummary,
    Patients
  },
  data: () => ({
    stepPosition: 1,
    title: '',
    description: '',
    selectedCustomers: [],
    headerInfo: [
      { title: 'Create segment', description: 'Enter your segment name and description below.' },
      { title: 'Choose customers', description: 'Any selected customer will automatically added to segment' },
      { title: 'Finishing up', description: 'Check the details of your segment' }
    ]
  }),
  computed: {
    breadcrumbItems () {
      return [
        { text: 'Segments', disabled: false, href: `/admin/${this.os}/segments` },
        { text: 'New segment by customers list', disabled: true }
      ]
    },
    audienceComponent () {
      return this.os === 'clinic' ? 'patients' : 'customer-list'
    }
  },
  methods: {
    clickContinue () {
      this.stepPosition = 3
    },
    onContinue (list) {
      this.selectedCustomers = list
      this.stepPosition = 3
    },
    backToName () {
      this.stepPosition = 1
    },
    onBack () {
      this.stepPosition = 2
    },
    updateSelectedCustomers (list) {
      this.selectedCustomers = list
    }
  }
}
</script>